(()=>{
const filterCloseButtons = document.querySelectorAll('.collection-filters__header svg')

filterCloseButtons.forEach((filterCloseButton)=>{
	filterCloseButton.addEventListener('click', ()=>{
		const openFilterModals = document.querySelectorAll('.mobile-filter-sort__filters[style="display: flex;"]')
		openFilterModals.forEach((openFilterModal)=>{
			openFilterModal.style.display="none"
		})
	})
})



document.addEventListener('DOMContentLoaded',()=>{
	const collectionContainerGrid = document.querySelector('.shopify-section.section-collection #products')

	let isCollectionLoading = false
	let pageIndex
	
	const params = new URLSearchParams(urlString);
	let page = parseInt(params.get('page'), 10);
	if (Number.isNaN(page) || page < 1) {
		page = 1
	}
	pageIndex = page + 1

	const isBottomVisible = (element) => {
		const rect = element.getBoundingClientRect();
		const viewportHeight = window.innerHeight || document.documentElement.clientHeight;  
		return rect.bottom >= 0 && (rect.bottom-1500) <= viewportHeight;
	  }
	
	const getMoreCollectionItems = (path) => {
		fetch(path) // könnte egal welche seite sein
		.then((response) => response.text())
		.then((responseText) => {
			const html = new DOMParser().parseFromString(responseText, 'text/html')
			const products = html.querySelectorAll('.shopify-section.section-collection .products .products__product')
			
			products.forEach((product) => {
				const images = product.querySelectorAll('img')
				images.forEach((image) => {
					const dataSrc = image.getAttribute('data-src')
					if (!dataSrc) return

					image.setAttribute('src', dataSrc)
					image.classList.remove('preload')
				})
				const videos = product.querySelectorAll('video')
				videos.forEach((video) => {
					const dataSrc = video.getAttribute('data-src')
					if (!dataSrc) return

					video.setAttribute('src', dataSrc)
					video.classList.remove('preload')
				})

				collectionContainerGrid.append(product)
			}) 

			pageIndex = pageIndex + 1
			const productCountElements = document.querySelectorAll('.section-collection__header .product-count')
			productCountElements.forEach((productCountElement)=>{
				const productCount = parseInt(productCountElement.innerText)
				productCountElement.innerText = productCount + products.length
			})
			isCollectionLoading = false
		});
	}

	const handleLoading = async () => {
		const reachedCollectionEnd = isBottomVisible(collectionContainerGrid)

		if (reachedCollectionEnd == true && isCollectionLoading == false) {
		
			let searchParameter

			if (window.location.search == '') {
				searchParameter =  '?'
			} else {
				searchParameter = window.location.search
			}

			const path = `${location.pathname + searchParameter}&page=${pageIndex}`  
			isCollectionLoading = true
			getMoreCollectionItems(path)

		}
	}
	
	window.addEventListener('scroll',handleLoading)
})

})()
